import { transformProgressDetailsDto } from 'data/transformers/payout';
export const transformPayout = _ref => {
  let {
    amount,
    currency,
    progress_details
  } = _ref;
  return {
    amount,
    currency,
    progressDetails: progress_details.map(transformProgressDetailsDto)
  };
};
export const transformPayoutConfiguration = _ref2 => {
  let {
    amount,
    note
  } = _ref2;
  return {
    amount: amount.amount,
    currency: amount.currency_code,
    note
  };
};